import { Reducer } from 'redux';
import { InvoiceConfigActions, InvoiceConfigActionTypes } from './actionTypes';
import { InvoiceConfig } from './types';
import { ErrorResponse } from 'core/http/response';

export type InvoicesConfigState = {
    config: InvoiceConfig | undefined;
    isLoading: boolean;
    error: ErrorResponse | undefined;
};

export const initialInvoicesConfigState: Readonly<InvoicesConfigState> = {
    config: {
        emailTemplate: null,
        invoiceDueDays: null,
        standardTerms: null,
        dueDateAlert: null,
        additionalCharge: null,
        bankAccount: [],
        paymentLink: null,
        paymentNotes: null,
    },
    isLoading: false,
    error: undefined,
};

const invoiceConfigReducer: Reducer<InvoicesConfigState, InvoiceConfigActionTypes> = (
    state = initialInvoicesConfigState,
    action
) => {
    switch (action.type) {
        case InvoiceConfigActions.GET_INVOICE_CONFIG_SUCCESS: {
            return {
                isLoading: false,
                error: undefined,
                config: action.payload,
            };
        }

        case InvoiceConfigActions.UPDATE_INVOICE_CONFIG_SUCCESS: {
            return {
                isLoading: false,
                error: undefined,
                config: action.payload,
            };
        }

        case InvoiceConfigActions.GET_INVOICE_CONFIG_REQUEST:
        case InvoiceConfigActions.UPDATE_INVOICE_CONFIG_REQUEST: {
            return {
                ...state,
                isLoading: true,
            };
        }

        case InvoiceConfigActions.GET_INVOICE_CONFIG_ERROR:
        case InvoiceConfigActions.UPDATE_INVOICE_CONFIG_ERROR: {
            return {
                ...state,
                isLoading: false,
                error: action.error,
            };
        }

        default: {
            return state;
        }
    }
};

export default invoiceConfigReducer;
